<template>
    <div>
        <v-row>
            <v-col cols="12">
                <h1 class="headline font-weight-light mb-3">
                    <router-link class="link-a" :to="backLink">
                        Mileage</router-link
                    >
                    / Detail
                    <!-- ดูรอบที่ปิดแล้ว (เข้ามาจากปุ่มโซนตอนเลือกรอบเก่า) -->
                    <v-chip
                        v-if="isPastRound"
                        small
                        label
                        color="blue-grey darken-2"
                        text-color="white"
                        class="ml-2"
                    >
                        <v-icon left small>mdi-history</v-icon>
                        รอบ {{ data_main.paycode }} · ปิดแล้ว · ดูย้อนหลัง
                    </v-chip>
                </h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6" md="4">
                <v-card
                    class="mx-auto"
                    max-width="400"
                    color="blue-grey darken-2"
                >
                    <v-list class="transparent">
                        <v-list-item>
                            <v-progress-linear
                                v-if="chk_data_main == true"
                                color="orange accent-4"
                                indeterminate
                            ></v-progress-linear>

                            <v-list-item-title
                                class="headline color-1"
                                v-if="chk_data_main == false"
                                >{{ data_main.paycode }}</v-list-item-title
                            >
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-title class="headline color-1">
                                {{ data_main.tl_name }}
                            </v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                <b class="text-right color-1"
                                    >{{ data_main_summary.sum_currency }}
                                    THB.
                                </b>
                            </v-list-item-subtitle>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-title class="color-f"
                                >Avg. Case / CE</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right color-f">
                                {{ data_main_summary.vol_job }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="color-f"
                                >Avg. Distance / Case</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right color-f">
                                {{ data_main_summary.distance }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="color-f"
                                >Avg. Cost / Case</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right color-f">
                                {{ data_main_summary.cost }}
                            </v-list-item-subtitle>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-subtitle class="text-center">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="cur-p2"
                                            @click="get_data('all')"
                                        >
                                            <v-icon class="mr-1 fix-font-1ea">
                                                mdi-account-circle
                                            </v-icon>
                                            <span
                                                class="subheading  fix-font-1ea"
                                                >{{
                                                    data_main_summary.total
                                                }}</span
                                            >
                                        </span>
                                    </template>
                                    <span>All</span>
                                </v-tooltip>

                                <span class="ml-2 mr-2 fix-font-ea">·</span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="cur-p2"
                                            @click="get_data('pending')"
                                        >
                                            <v-icon class="mr-1 fix-font-2ea">
                                                mdi-alert-circle
                                            </v-icon>
                                            <span
                                                class="subheading  fix-font-2ea"
                                                >{{
                                                    data_main_summary.pending
                                                }}</span
                                            >
                                        </span>
                                    </template>
                                    <span>Pending</span>
                                </v-tooltip>

                                <span class="ml-2 mr-2 fix-font-ea">·</span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="cur-p2"
                                            @click="get_data('reject')"
                                        >
                                            <v-icon class="mr-1 fix-font-4ea">
                                                mdi-close-circle
                                            </v-icon>
                                            <span
                                                class="subheading fix-font-4ea"
                                                >{{
                                                    data_main_summary.reject
                                                }}</span
                                            >
                                        </span>
                                    </template>
                                    <span>Reject</span>
                                </v-tooltip>
                                <span class="ml-2 mr-2 fix-font-ea">·</span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="cur-p2"
                                            @click="get_data('approved')"
                                        >
                                            <v-icon class="mr-1 fix-font-3ea">
                                                mdi-checkbox-marked-circle
                                            </v-icon>
                                            <span
                                                class="subheading fix-font-3ea"
                                                >{{
                                                    data_main_summary.approved
                                                }}</span
                                            >
                                        </span>
                                    </template>
                                    <span>Approved</span>
                                </v-tooltip>
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-card class="mx-auto" max-width="400" color="blue lighten-3">
                    <v-list-item two-line>
                        <v-list-item-title class="headline color-3">
                            Top volume cases w/o return
                        </v-list-item-title>
                    </v-list-item>
                    <v-progress-linear
                        v-if="data_top_mileage.length == 0"
                        indeterminate
                        color="orange accent-4"
                    ></v-progress-linear>

                    <v-list
                        class="transparent"
                        v-if="data_top_mileage.length > 0"
                    >
                        <v-list-item
                            v-for="(row_m, index_m) in data_top_mileage"
                            :key="index_m"
                        >
                            <v-list-item-title>
                                {{ index_m + 1 + ". " + row_m.ce_name }}
                            </v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ row_m.volume_job }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-progress-linear
                            v-if="chk_view_top1 == true"
                            indeterminate
                            color="orange accent-4"
                        ></v-progress-linear>
                        <v-btn
                            v-if="chk_view_top1 == false"
                            text
                            class="btn-view-m-2"
                            @click="get_view_top('volume')"
                        >
                            View More
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
                <v-card class="mx-auto" max-width="400" color="blue lighten-3">
                    <v-list-item two-line>
                        <v-list-item-title class="headline color-3">
                            Top onsite distances w/o return (km)
                        </v-list-item-title>
                    </v-list-item>
                    <v-progress-linear
                        v-if="data_top_km.length == 0"
                        indeterminate
                        color="orange accent-4"
                    ></v-progress-linear>

                    <v-list class="transparent" v-if="data_top_km.length > 0">
                        <v-list-item
                            v-for="(row_km, index_km) in data_top_km"
                            :key="index_km"
                        >
                            <v-list-item-title>
                                {{ index_km + 1 + ". " + row_km.ce_name }}
                            </v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ row_km.sum_km }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-progress-linear
                            v-if="chk_view_top2 == true"
                            indeterminate
                            color="orange accent-4"
                        ></v-progress-linear>
                        <v-btn
                            v-if="chk_view_top2 == false"
                            text
                            class="btn-view-m-2"
                            @click="get_view_top('distance')"
                        >
                            View More
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <div v-if="chk_data_main == true">
            <v-row>
                <v-col cols="12">
                    <v-progress-linear
                        indeterminate
                        color="orange accent-4"
                    ></v-progress-linear>
                </v-col>
            </v-row>
        </div>
        <!-- {{ data_main["branchs"].length }} -->
        <div v-if="chk_data_main == false">
            <div v-for="(r, i) in data_main['branchs']" :key="i">
                <v-row v-if="r.engineer.length > 0">
                    <v-col cols="12" class="fix-h-province">{{
                        r.branch_name
                    }}</v-col>

                    <v-col
                        cols="12"
                        v-for="(rowCe, num) in r.engineer"
                        :key="num"
                        class="mar-t-10"
                    >
                        <v-card class="mx-auto" color="blue lighten-4" dark>
                            <v-card-text>
                                <v-row class="mar-t-13">
                                    <v-col cols="12" sm="6"
                                        ><v-btn
                                            text
                                            class="btn-detail"
                                            @click="
                                                view_emp(
                                                    rowCe.emp_id,
                                                    rowCe.emp_name_en,
                                                    rowCe.emp_surname_en,
                                                    rowCe.paycode
                                                )
                                            "
                                            >{{
                                                rowCe.emp_name_en +
                                                    " " +
                                                    rowCe.emp_surname_en
                                            }}

                                            <span
                                                class="red--text ml-2"
                                                v-if="
                                                    data_main.paycode !=
                                                        rowCe.paycode
                                                "
                                            >
                                                {{ rowCe.paycode }}
                                            </span></v-btn
                                        >
                                    </v-col>

                                    <!-- STATUS -->
                                    <v-col cols="12" sm="6" class="text-right">
                                        <v-btn
                                            small
                                            color="white"
                                            class="mr-5 primary--text"
                                            v-if="rowCe.logs.length > 0"
                                            rounded
                                            @click="open_log(rowCe.logs)"
                                        >
                                            <v-icon left small
                                                >mdi-magnify</v-icon
                                            >
                                            View Approve Log
                                        </v-btn>

                                        <v-btn-toggle rounded>
                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                    }"
                                                >
                                                    <v-btn
                                                        small
                                                        v-on="on"
                                                        :color="
                                                            rowCe.approve_status
                                                                .requested_status ===
                                                            'not approve'
                                                                ? 'yellow darken-1'
                                                                : rowCe
                                                                      .approve_status
                                                                      .requested_status ===
                                                                  null
                                                                ? 'blue-grey darken-2'
                                                                : 'green accent-3'
                                                        "
                                                    >
                                                        CE
                                                    </v-btn>
                                                </template>
                                                <span>{{
                                                    rowCe.approve_status
                                                        .requested_date
                                                }}</span>
                                            </v-tooltip>

                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                    }"
                                                >
                                                    <v-btn
                                                        small
                                                        v-on="on"
                                                        :color="
                                                            chk_approve_color(
                                                                rowCe
                                                                    .approve_status
                                                                    .requested_status,
                                                                1,
                                                                rowCe
                                                                    .approve_status
                                                                    .head_status
                                                            )
                                                        "
                                                    >
                                                        TL
                                                    </v-btn>
                                                </template>
                                                <span>{{
                                                    rowCe.approve_status
                                                        .head_date
                                                }}</span>
                                            </v-tooltip>

                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                    }"
                                                >
                                                    <v-btn
                                                        v-on="on"
                                                        small
                                                        :color="
                                                            chk_approve_color(
                                                                rowCe
                                                                    .approve_status
                                                                    .requested_status,
                                                                2,
                                                                rowCe
                                                                    .approve_status
                                                                    .mgr_status
                                                            )
                                                        "
                                                    >
                                                        MGR
                                                    </v-btn>
                                                </template>
                                                <span>{{
                                                    rowCe.approve_status
                                                        .mgr_date
                                                }}</span>
                                            </v-tooltip>

                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                    }"
                                                >
                                                    <v-btn
                                                        v-on="on"
                                                        small
                                                        :color="
                                                            chk_approve_color(
                                                                rowCe
                                                                    .approve_status
                                                                    .requested_status,
                                                                3,
                                                                rowCe
                                                                    .approve_status
                                                                    .md_status
                                                            )
                                                        "
                                                    >
                                                        MD
                                                    </v-btn>
                                                </template>
                                                <span>{{
                                                    rowCe.approve_status.md_date
                                                }}</span>
                                            </v-tooltip>
                                        </v-btn-toggle>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Total Expense</span
                                        >

                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.currency }}</span
                                        >
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Total KM</span
                                        >

                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.km }}</span
                                        >
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Dist./case</span
                                        >

                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.distance }}</span
                                        >
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Cost/case</span
                                        >

                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.cost }}</span
                                        >
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Vol w/o return</span
                                        >

                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.vol_job_wo_return }}</span
                                        >
                                    </v-col>

                                    <!-- new -->
                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Vol. Job Onsite</span
                                        >
                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.job_onsite }}</span
                                        >
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Vol. Job BenchO</span
                                        >
                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.job_benchO }}</span
                                        >
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Vol. Job Bench</span
                                        >
                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.job_bench }}</span
                                        >
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Vol. Return</span
                                        >
                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.job_return }}</span
                                        >
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                        ><span class="fix-das-aa"
                                            >Vol. Return - Pickup</span
                                        >
                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.job_return_pickup }}</span
                                        >
                                    </v-col>
                                    <!-- End new -->

                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                    >
                                        <span class="fix-das-aa"
                                            >Cannot contact cust.</span
                                        >

                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{
                                                rowCe.cannot_contact_count
                                            }}</span
                                        >
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        class="fix-border-expense-b"
                                    >
                                        <span class="fix-das-aa"
                                            >Reschedule</span
                                        >

                                        <span
                                            class="fix-das-aa"
                                            style="font-weight: bold; float:right;"
                                            >{{ rowCe.reschedule_count }}</span
                                        >
                                    </v-col>
                                </v-row>

                                <v-row
                                    v-if="rowCe.province.length > 0"
                                    class="fix-p mt-2"
                                >
                                    <v-col cols="12" style="margin-top:-5px;">
                                        <span class="fix-das-bb">
                                            volume job onsite by provinces
                                        </span>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        md="4"
                                        lg="3"
                                        style="margin-top:-5px;"
                                        class="fix-border-expense-b mb-1"
                                        v-for="(row_province,
                                        index_province) in rowCe.province"
                                        :key="index_province"
                                    >
                                        <span class="fix-das-aa">
                                            <b>{{
                                                index_province +
                                                    1 +
                                                    ". " +
                                                    row_province.province_name
                                            }}</b>
                                        </span>
                                        <span
                                            class="fix-das-aa "
                                            style="font-weight: bold; float:right;"
                                            >{{ row_province.volume_job }}</span
                                        >
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <!--  -->
                            <!-- <v-card-actions class="justify-center">
                            <v-btn block text
                                ><span style="font-size:15px;color:#1565C0;">
                                    View Detail</span
                                ></v-btn
                            >
                        </v-card-actions> -->
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="text-center">
            <v-dialog v-model="dialog" class="mx-auto" max-width="375">
                <v-card>
                    <v-card-text>
                        <div v-if="chk_member == true">
                            <br />
                            <v-progress-linear
                                color="orange accent-4"
                                indeterminate
                            ></v-progress-linear>
                        </div>

                        <div v-if="chk_member == false">
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <img
                                        :src="url_pic + member.img"
                                        :alt="member.name"
                                        width="50%"
                                    />
                                </v-col>
                                <v-col cols="12" class="mar-t-20 text-center">
                                    <span class="fix-das-bb">{{
                                        member.name
                                    }}</span>
                                    <br />
                                    {{ member.team }}
                                </v-col>

                                <v-col cols="12" class="text-center mar-t-10">
                                    <div
                                        v-for="(row_e, index_e) in member.data"
                                        :key="index_e"
                                    >
                                        <v-list-item class="mar-t-10">
                                            <v-list-item-title
                                                class="text-center"
                                            >
                                                <span class="fix-das-bb">{{
                                                    row_e.paycode
                                                }}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="mar-t-20">
                                            <v-list-item-subtitle
                                                class="text-center"
                                            >
                                                <v-chip small>{{
                                                    row_e.sum_currency + " THB."
                                                }}</v-chip>
                                                <v-chip
                                                    small
                                                    class="ml-2 mr-2"
                                                    >{{
                                                        row_e.sum_km + " Km."
                                                    }}</v-chip
                                                >
                                                <v-chip small>{{
                                                    row_e.volume_job + " Job."
                                                }}</v-chip>
                                            </v-list-item-subtitle>
                                        </v-list-item>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>

                    <v-divider v-if="chk_member == false"></v-divider>

                    <v-card-actions v-if="chk_member == false">
                        <v-spacer></v-spacer>
                        <v-btn
                            small
                            class="btn-detail mt-1 mb-1"
                            text
                            @click="func_approve()"
                        >
                            View More
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogLog" width="500">
                <v-card>
                    <v-card-title class="subtitle-1 primary--text">
                        APPROVE LOG
                    </v-card-title>
                    <v-card-text>
                        <v-row v-for="(log, idx) in data_log" :key="idx">
                            <v-col cols="6">
                                <b
                                    >{{ log.log_date }}
                                    -
                                    {{ log.log_name }}
                                </b>
                            </v-col>
                            <v-col cols="6">
                                {{ log.log_note }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="dialogLog = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <v-row justify="center">
            <v-dialog
                v-model="dialogViewTop"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialogViewTop = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <v-toolbar-title
                            >View All Performance w/o return ( by
                            {{ form_top_view.type }} )
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <ViewTop
                            :data_top="data_top"
                            :form_top_view="form_top_view"
                        />
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>

        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import ViewTop from "./components/ViewTopOnsite"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        ViewTop,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        this.get_tl_id()
    },
    mounted() {
        // this.get_tl_id()
    },
    computed: {
        ...mapState(["isLoading"]),
        // backend ส่ง is_active มาด้วย ถ้าไม่มี (backend เก่า) ถือเป็นรอบปัจจุบัน
        isPastRound() {
            return !!this.qPaycode && this.data_main.is_active === false
        },
        backLink() {
            return this.qPaycode
                ? { path: "/Expense/Mileage", query: { paycode: this.qPaycode } }
                : "/Expense/Mileage"
        },
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        // ?paycode= สำหรับดูรอบย้อนหลัง ("" = รอบปัจจุบัน เหมือนเดิม)
        pq() {
            return this.qPaycode
                ? "?paycode=" + encodeURIComponent(this.qPaycode)
                : ""
        },
        async get_tl_id() {
            if (this.role_name == "TL") {
                this.mutateIsLoading()
                await axios
                    .get(url + "account-detail", {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    })
                    .then((response) => {
                        this.mutateIsLoading()
                        this.tl_id = response.data.emp_id
                    })
                    .catch((error) => {
                        this.mutateIsLoading()
                        console.log(error)
                    })
            } else if (
                this.role_name == "Management" ||
                this.team_name == "HR" ||
                this.emp_img == "P06-297"
            ) {
                // console.log(this.$route.params.emp_id, "-- test log")
                this.tl_id = this.$route.params.emp_id
            }

            this.load_all()
        },
        // ยิง 3 API พร้อมกัน (เดิมยิงต่อกันทีละตัว เวลารวม = ผลบวกของทั้งสาม)
        async load_all() {
            this.chk_data_main = true
            await Promise.all([
                this.get_top_mileage(),
                this.get_top_km(),
                this.get_data(),
            ])
        },
        async get_top_mileage() {
            this.chk_data_main = true
            await axios
                .get(url + "mileage-ce-graph/" + this.tl_id + this.pq())
                .then((response) => {
                    this.data_top_mileage = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_top_km() {
            await axios
                .get(url + "mileage-miles-graph/" + this.tl_id + this.pq())
                .then((response) => {
                    this.data_top_km = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data(st) {
            let send
            if (st == undefined || st == "") {
                send = { status: this.type_status }
            } else {
                send = { status: st }
                this.type_status = st
            }
            if (this.qPaycode) send.paycode = this.qPaycode

            console.log(this.tl_id)

            await axios
                .post(
                    url + "mileage-approve-summary/" + this.tl_id,
                    send,
                    this.tk
                )
                .then((response) => {
                    // console.log(response.data)
                    this.chk_data_main = false
                    this.data_main = response.data
                    this.data_main_summary = response.data.summary
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        formatToPrice(v) {
            return `${v.toFixed()}`
        },
        chk_approve_color(st, n, st2) {
            if (n === 1) {
                if (st === "request") {
                    return "yellow darken-1"
                } else if (st === "head approve" || st2 === "approve") {
                    return "green accent-3"
                } else if (st2 === "not approve") {
                    return "red accent-2"
                } else {
                    return "blue-grey darken-2"
                }
            } else if (n === 2) {
                if (st === "head approve") {
                    return "yellow darken-1"
                } else if (st === "mgr approve" || st2 === "approve") {
                    return "green accent-3"
                } else if (st2 === "not approve") {
                    return "red accent-2"
                } else {
                    return "blue-grey darken-2"
                }
            } else if (n === 3) {
                if (st === "mgr approve") {
                    return "yellow darken-1"
                } else if (st === "md approve" || st2 === "approve") {
                    return "green accent-3"
                } else if (st2 === "not approve") {
                    return "red accent-2"
                } else {
                    return "blue-grey darken-2"
                }
            }
        },
        async view_emp(empId, name, s_name, paycodex) {
            this.dialog = true
            this.chk_member = true
            this.emp_id = empId
            this.paycode = paycodex
            this.member.name = name + " " + s_name

            await axios
                .get(url + "mileage-approve/view-detail/" + this.emp_id + this.pq())
                .then((response) => {
                    this.chk_member = false
                    this.member.img = response.data.file_store_name
                    this.member.team = response.data.team_name
                    this.member.data = response.data.expenses
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        func_approve() {
            // this.$root.$router.push({
            //     path:
            //         "/Expense/Mileage/Tl/" +
            //         this.type_status +
            //         "/" +
            //         this.emp_id,
            //     query: { q: this.tl_id },
            // })

            let routeData = this.$router.resolve({
                path:
                    "/Expense/Mileage/Tl/" +
                    this.type_status +
                    "/" +
                    this.emp_id,
                query: { q: this.tl_id, p: this.paycode },
            })
            window.open(routeData.href, "_blank")
        },
        open_log(data) {
            this.data_log = data
            this.dialogLog = true
        },
        async get_view_top(ty) {
            ty == "volume"
                ? (this.chk_view_top1 = true)
                : (this.chk_view_top2 = true)
            this.form_top_view.type = ty
            this.form_top_view.tl_id = this.tl_id
            if (this.qPaycode) this.form_top_view.paycode = this.qPaycode
            await axios
                .post(url + "mileage-graph-all", this.form_top_view, {})
                .then((response) => {
                    this.data_top = response.data
                    this.chk_view_top1 = false
                    this.chk_view_top2 = false
                    this.dialogViewTop = true
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            data_log: [],
            chk_data_main: false,
            data_main: [],
            data_main_summary: [],
            data_top_mileage: [],
            data_top_km: [],
            tk: "",
            tl_id: "",
            duration_time: 2500,
            dialog: false,
            emp_id: null,
            chk_member: false,
            member: {
                name: null, //localStorage.fullname,
                team: null,
                img: null, // img: localStorage.emp_img,
                data: [],
            },
            role_name: localStorage.role_name,
            team_name: localStorage.team_name,
            emp_img: localStorage.emp_img,
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/profile_img/`,
            dialogLog: false,
            chk_view_top1: false,
            chk_view_top2: false,
            data_top: [],
            dialogViewTop: false,
            form_top_view: {
                type: "",
                tl_id: "",
            },
            type_status: this.$route.params.type_status,
            paycode: "",
            qPaycode: this.$route.query.paycode || "",
        }
    },
}
</script>
<style scoped>
.fix-das-aa {
    color: rgb(52, 68, 109) !important;
    font-size: 14px;
    /* font-weight: bold; */
}
.fix-das-bb {
    color: rgb(52, 68, 109) !important;
    font-size: 17px;
    font-weight: bold;
}

.mar-t-13 {
    margin-top: -13px !important;
}
.fix-h-province {
    background-color: #0c374e;
    border-radius: 4px;
    margin-left: 10px;
    margin-bottom: 3px;
    margin-top: 10px;
    font-weight: bold;
    color: #fffb00;
}
.fix-border-expense-b {
    /* border-left: 1px solid #85d1d4; */
    border-right: 2px solid #85d1d4;
}
.fix-font-h1 {
    color: #0d465d;
    font-weight: 900;
}
.fix-font-h2 {
    color: #ffffff;
    font-weight: 900;
}
.color-f {
    color: #ffffff !important;
}

.color-1 {
    color: #00ff3b;
}

.fix-p {
    background-color: #fff !important;
    border-radius: 10px;
}
.btn-detail {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #3e6d87;
}
.btn-detail:hover {
    color: #fffb00 !important;
    background-color: #0c374e !important;
}
.btn-view-m-2 {
    color: #01152c;
}
.btn-view-m-2:hover {
    color: #9ac6f0;
    background-color: #326586;
}

.fix-font-ea {
    color: #fff;
    font-weight: bold;
}
.fix-font-1ea {
    color: #a1ecd6;
    font-weight: bold;
}
.fix-font-2ea {
    color: #fae06c;
    font-weight: bold;
}
.fix-font-3ea {
    color: #00ff3b;
    font-weight: bold;
}
.fix-font-4ea {
    color: #ff6262;
    font-weight: bold;
}

.fix-font-1ea:hover {
    color: #00d897;
    font-weight: bold;
}
.fix-font-2ea:hover {
    color: #c29e00;
    font-weight: bold;
}
.fix-font-3ea:hover {
    color: #00b129;
    font-weight: bold;
}
.fix-font-4ea:hover {
    color: #d60000;
    font-weight: bold;
}
.cur-p2 {
    cursor: pointer;
}
</style>
